import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const QuotationForm = () => {
  const [formData, setFormData] = useState({
    companyName: '',
    address: '',
    country: '',
    contactName: '',
    designation: '',
    email: '',
    altEmail: '',
    officeNumber: '',
    mobileNumber: '',
    vesselName: '',
    imoNumber: '',
    vesselType: '',
    jobDescription: '',
    location: '',
    urgency: '',
  });

  const [, setFiles] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFiles(e.target.files);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const subject = `Quotation Request - ${formData.vesselName} (${formData.companyName})`;
    const body = `
Company Information:
-------------------
Company Name: ${formData.companyName}
Address: ${formData.address}
Country: ${formData.country}

Contact Details:
---------------
Name: ${formData.contactName}
Designation: ${formData.designation}
Email: ${formData.email}
Alternate Email: ${formData.altEmail}
Office Number: ${formData.officeNumber}
Mobile Number: ${formData.mobileNumber}

Vessel / Boat Information:
-------------------------
Vessel Name: ${formData.vesselName}
IMO Number: ${formData.imoNumber}
Vessel Type: ${formData.vesselType}

Job Scope:
---------
Description: ${formData.jobDescription}
Location: ${formData.location}
Urgency: ${formData.urgency}

Note for Sender:
---------------
If you attached files to the form (Photos, Drawings, Reports), please remember to manually attach them to the email that just opened.
`;

    const mailtoUrl = `mailto:estimation@theciap.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    // Open the email client
    window.location.href = mailtoUrl;

    alert("Quotation summary generated! Your email client will now open. Please click 'Send' in your email app and remember to attach any documents you selected.");
  };

  return (
    <div className='page-wrapper'>
      <Navbar />

      {/* Background Wrapper Start */}
      <div className="shipping-bg-wrapper">
        <video autoPlay loop muted playsInline className='background-video'>
          <source src="/videos/aboutus-video.mp4" type="video/mp4" />
        </video>
        <div className="overlay">
          <div className="quotation-container">
            <div className="form-header">
              <h2>Quotation Request</h2>
              <p>Please provide the details below for your vessel modification requirements.</p>
            </div>

            <form onSubmit={handleSubmit} className="quote-form">
              {/* 1. Company Information */}
              <fieldset>
                <legend>1. Company Information</legend>
                <input type="text" name="companyName" placeholder="Company Name" onChange={handleChange} required />
                <textarea name="address" placeholder="Address" onChange={handleChange} />
                <input type="text" name="country" placeholder="Country" onChange={handleChange} />
              </fieldset>

              {/* 2. Contact Details */}
              <fieldset>
                <legend>2. Contact Details</legend>
                <input type="text" name="contactName" placeholder="Contact Person Name" onChange={handleChange} required />
                <input type="text" name="designation" placeholder="Designation" onChange={handleChange} />
                <input type="email" name="email" placeholder="Email Address" onChange={handleChange} required />
                <input type="email" name="altEmail" placeholder="Alternate Email" onChange={handleChange} />
                <input type="tel" name="officeNumber" placeholder="Office Number" onChange={handleChange} />
                <input type="tel" name="mobileNumber" placeholder="Mobile Number" onChange={handleChange} required />
              </fieldset>

              {/* 3. Vessel Information */}
              <fieldset>
                <legend>3. Vessel / Boat Information</legend>
                <input type="text" name="vesselName" placeholder="Vessel Name" onChange={handleChange} required />
                <input type="text" name="imoNumber" placeholder="IMO Number" onChange={handleChange} />
                <select name="vesselType" onChange={handleChange} required>
                  <option value="">Select Vessel Type</option>
                  <option value="Container Vessel">Container Vessel</option>
                  <option value="Bulk Carrier">Bulk Carrier</option>
                  <option value="Tanker">Tanker</option>
                  <option value="Passenger Vessel">Passenger Vessel</option>
                  <option value="Tug Boat">Tug Boat</option>
                  <option value="Offshore Support Vessel">Offshore Support Vessel</option>
                  <option value="Fishing Vessel">Fishing Vessel</option>
                  <option value="Barge / Work Boat">Barge / Work Boat</option>
                  <option value="Other">Other</option>
                </select>
              </fieldset>

              {/* 4. Job Scope */}
              <fieldset>
                <legend>4. Job Scope Description</legend>
                <textarea name="jobDescription" placeholder="Describe the required work in detail" onChange={handleChange} required />
                <input type="text" name="location" placeholder="Location of Vessel / Equipment" onChange={handleChange} />
                <select name="urgency" onChange={handleChange} required>
                  <option value="">Select Urgency</option>
                  <option value="Urgent">Urgent</option>
                  <option value="Within 1 Week">Within 1 Week</option>
                  <option value="Planned Maintenance">Planned Maintenance</option>
                  <option value="Other">Other</option>
                </select>
              </fieldset>

              {/* 5. Attachments */}
              <fieldset>
                <legend>5. Supporting Documents</legend>
                <p className="hint">Attach photos, drawings, reports, or specifications</p>
                <input type="file" multiple onChange={handleFileChange} />
              </fieldset>

              <button type="submit" className="submit-btn">Submit Quotation Request</button>
            </form>
          </div>
        </div>
      </div>
      {/* Background Wrapper End */}

      <Footer />
    </div>
  );
};

export default QuotationForm;